module.exports = __webpack_public_path__ + "img/loader-white.d20e18b8.svg";